import { useRef as S, useMemo as v, useEffect as y, useState as $, useSyncExternalStore as x } from "react";
import d, { z as w } from "zod";
import { jsx as A } from "react/jsx-runtime";
import { isValidElementType as b, isForwardRef as _ } from "react-is";
const m = (t) => Array.isArray(t) && t.every(
  (e) => Array.isArray(e) && e.length === 2 && typeof e[1] == "function"
), G = (t, { ifDefined: e, ifTrue: r, ifFalse: n, ifOfType: o } = {}) => {
  const s = S(), c = S(!1), a = v(
    () => Array.isArray(e) && e.length > 0 || Array.isArray(r) && r.length > 0 || Array.isArray(n) && n.length > 0 || m(o),
    [e, r, n, o]
  ), E = v(() => {
    if (m(o))
      return o.map((u) => u[0]).flat();
  }, [o]);
  y(
    () => {
      var u, g, h;
      if (!((u = e == null ? void 0 : e.some) != null && u.call(e, (i) => typeof i > "u") || (g = r == null ? void 0 : r.some) != null && g.call(r, (i) => i === !1) || (h = n == null ? void 0 : n.some) != null && h.call(n, (i) => i === !0) || m(o) && o.some(([i, I]) => !I(i))))
        return c.current || (s.current = t(), c.current = !0), () => {
          c.current && typeof s.current == "function" && s.current();
        };
    },
    a ? [
      ...e ?? [],
      ...r ?? [],
      ...n ?? [],
      ...E ?? []
    ] : void 0
  );
}, H = () => {
  if (typeof window > "u")
    return !1;
  const t = window.navigator.userAgent || "";
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(t);
}, U = ({
  refElement: t,
  threshold: e = 0.1
}) => {
  const [r, n] = $(!1);
  return y(() => {
    const o = e ? { threshold: e } : { threshold: 0.1 }, s = t.current, c = new IntersectionObserver(([a]) => {
      a != null && a.isIntersecting && !r && n(!0);
    }, o);
    return s && c.observe(s), () => {
      s && c.unobserve(s);
    };
  }, [t.current]), r;
};
function q(t, e) {
  let r;
  return (...n) => (clearTimeout(r), new Promise((o) => {
    r = setTimeout(() => o(t(...n)), e);
  }));
}
const L = w.object({
  ip: w.string(),
  country: w.string()
}), Q = async () => {
  const t = await fetch("https://api.country.is/", {
    method: "GET",
    headers: { "Content-Type": "application/json" }
  }).then((e) => {
    if (!e.ok)
      throw e;
    return e.json();
  }).catch((e) => {
    console.log(e);
  });
  if (!L.safeParse(t).success) {
    console.error("Invalid geoip location response", JSON.stringify(t));
    return;
  }
  return t;
};
function N(t, e) {
  return e > 0 ? Math.trunc(t) : Math.round(t);
}
function X(t, e) {
  const r = parseInt(e.decimalDigits ?? "0"), n = t % 1, o = N(t, r).toString().replace(/\B(?=(\d{3})+(?!\d))/g, e.thousandsSeparator ?? " "), s = r > 0 ? `${e.decimalPoint}${String(
    Math.round(n * Math.pow(10, r))
  ).padStart(r, "0")}` : "";
  return `${e.prefix}${o}${s}${e.suffix}`;
}
class p {
  static setWithExpiry(e, r, n) {
    if (typeof window > "u" || !("localStorage" in window))
      return;
    const o = {
      value: r,
      expiry: Date.now() + n * 1e3
    };
    localStorage.setItem(e, JSON.stringify(o));
  }
  static getWithExpiry(e) {
    if (typeof window > "u" || !("localStorage" in window))
      return;
    const r = localStorage.getItem(e);
    if (r)
      try {
        const n = JSON.parse(r);
        if (Date.now() > n.expiry) {
          localStorage.removeItem(e);
          return;
        }
        return n.value;
      } catch (n) {
        console.warn("Trying to access local storage item without expiry", n);
        return;
      }
  }
  /**
   *
   * @deprecated use `remove` instead
   */
  static delete(e) {
    return p.remove(e);
  }
  static remove(e) {
    typeof window > "u" || !("localStorage" in window) || localStorage.removeItem(e);
  }
}
function Y(t) {
  return t.replace(/\/+/g, "/").replace(/\/+$/, "").replace(/^\//, "").toLowerCase();
}
function Z(t) {
  return b(t) && _(/* @__PURE__ */ A(t, {}));
}
function V(t) {
  return b(t);
}
const C = (t) => t.tagName === "SCRIPT", P = (t) => !!t.src && t.src !== "", M = (t) => {
  var r, n;
  const e = document.createElement("script");
  e.text = t.innerHTML;
  for (let o = t.attributes.length - 1; o >= 0; o--) {
    const s = (r = t.attributes[o]) == null ? void 0 : r.name, c = (n = t.attributes[o]) == null ? void 0 : n.value;
    s && c && e.setAttribute(s, c);
  }
  return e;
}, k = (t) => {
  if (C(t) && !P(t))
    t.parentNode && t.parentNode.replaceChild(M(t), t);
  else {
    let e = 0;
    const r = t.childNodes;
    for (; e < r.length; )
      k(r[e++]);
  }
  return t;
};
function D(t) {
  return !(/^\/__webpack_hmr/.test(t.pathname) || /^\/build/.test(t.pathname) || /^\/media\//.test(t.pathname) || // magento images
  /\.(css|js|woff|ico)$/.test(t.pathname));
}
const R = d.object({ key: d.string(), newValue: d.string() });
function j(t) {
  return R.safeParse(t).success;
}
function O(t, e) {
  return (r) => (window.addEventListener(
    "storage",
    l(r, t, e)
  ), window.addEventListener(
    `update_localstorage_boolean_${t}`,
    l(r, t, e)
  ), () => {
    window.removeEventListener(
      "storage",
      l(r, t, e)
    ), window.removeEventListener(
      `update_localstorage_boolean_${t}`,
      l(r, t, e)
    );
  });
}
function f(t, e) {
  return () => {
    const r = p.getWithExpiry(t);
    if (r != null)
      try {
        return JSON.parse(r);
      } catch {
        return console.warn(
          `Could not parse localstorage entry on key ${t}. Falling back to ${e}`
        ), e;
      }
    return e;
  };
}
function l(t, e, r) {
  return (n) => {
    j(n) ? n.key !== e && !!n.newValue !== f(e, r)() && t() : t();
  };
}
const T = (t, e, r) => {
  const n = (s) => {
    if (typeof s != "boolean") {
      console.warn(
        `Tried to update LocalStorageBoolean with the non-boolean: ${s}`
      );
      return;
    }
    p.setWithExpiry(
      t,
      JSON.stringify(s),
      r ?? 2592e3
    ), window.dispatchEvent(
      new CustomEvent(`update_localstorage_boolean_${t}`)
    );
  };
  return [x(
    O(t, e),
    f(t, e),
    () => e
  ), n];
};
export {
  p as LocalStorage,
  q as debounce,
  Q as fetchGeoipLocation,
  X as formatCentraPrice,
  L as geoipLocationSchema,
  Z as isForwardRef,
  V as isValidComponent,
  Y as normalizeSlug,
  k as replaceScriptNode,
  D as shouldHandleUrl,
  G as useEffectOnce,
  H as useIsMobile,
  T as useLocalStorageBoolean,
  U as useSeenInViewpport
};
//# sourceMappingURL=lib.es.js.map
